/**
 * @file  src\pages\HomeLoadingSkeleton.js
 * @brief  This file is responsible for loading skeleton in home page.
 * @date   June, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React from "react";

const HomeLoadingSkeleton = (props) => {
  return (
    <>
      <div className="skeleton-wrapper">
        <div className="skeleton-img-wrap-outer">
          <div className="skeleton-img-wrap"></div>
        </div>
        <div className="skeleton-info-wrap">
          <div className="skelton-info-top"></div>
          <div className="skelton-info-middle"></div>
          <div className="skelton-info-bottom"></div>
          <div className="skeleton-tag-wrap">
            <div className="skeleton-tag-switch"></div>
          </div>
        </div>
        <div className="skeleton-btn-wrap">
          <div className="skeleton-btn"></div>
          <div className="skeleton-btn"></div>
        </div>
      </div>

      <div className="skeleton-wrapper">
        <div className="skeleton-img-wrap-outer">
          <div className="skeleton-img-wrap"></div>
        </div>
        <div className="skeleton-info-wrap">
          <div className="skelton-info-top"></div>
          <div className="skelton-info-middle"></div>
          <div className="skelton-info-bottom"></div>
          <div className="skeleton-tag-wrap">
            <div className="skeleton-tag-switch"></div>
          </div>
        </div>
        <div className="skeleton-btn-wrap">
          <div className="skeleton-btn"></div>
          <div className="skeleton-btn"></div>
        </div>
      </div>

      <div className="skeleton-wrapper">
        <div className="skeleton-img-wrap-outer">
          <div className="skeleton-img-wrap"></div>
        </div>
        <div className="skeleton-info-wrap">
          <div className="skelton-info-top"></div>
          <div className="skelton-info-middle"></div>
          <div className="skelton-info-bottom"></div>
          <div className="skeleton-tag-wrap">
            <div className="skeleton-tag-switch"></div>
          </div>
        </div>
        <div className="skeleton-btn-wrap">
          <div className="skeleton-btn"></div>
          <div className="skeleton-btn"></div>
        </div>
      </div>
      <div className="skeleton-wrapper">
        <div className="skeleton-img-wrap-outer">
          <div className="skeleton-img-wrap"></div>
        </div>
        <div className="skeleton-info-wrap">
          <div className="skelton-info-top"></div>
          <div className="skelton-info-middle"></div>
          <div className="skelton-info-bottom"></div>
          <div className="skeleton-tag-wrap">
            <div className="skeleton-tag-switch"></div>
          </div>
        </div>
        <div className="skeleton-btn-wrap">
          <div className="skeleton-btn"></div>
          <div className="skeleton-btn"></div>
        </div>
      </div>
    </>
  );
};

export default HomeLoadingSkeleton;
